
import dust from "dustjs-linkedin";


(function(){dust.register("lessons/lesson-creator/editor/seed",body_0);function body_0(chk,ctx){return chk.write("<div class=\"seed\"><div class=\"intro\"><p>").helper("i18n",ctx,{},{"id":"course_wizard_text_input_text"}).write("</p></div><textarea placeholder=\"").helper("i18n",ctx,{},{"id":"course_wizard_text_input_hint"}).write("\">").reference(ctx.get(["seedText"], false),ctx,"h").write("</textarea></div><div class=\"separator\"></div><div class=\"content\"></div>");}return body_0;})();

export default 0;
